import script from "./enunciado-demandas-form-pesquisa.vue?vue&type=script&setup=true&lang=js"
export * from "./enunciado-demandas-form-pesquisa.vue?vue&type=script&setup=true&lang=js"

import "./enunciado-demandas-form-pesquisa.vue?vue&type=style&index=0&id=669848dc&lang=scss"

const __exports__ = script;

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QBtn,QTooltip,QToggle,QSelect});
